// src/pages/SelectionOrders/components/BatchStatusChange.tsx
import React, { useState } from 'react';
import useSelectionOrderService from '../../../app/services/hooks/useSelectionOrderService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

interface Props {
  linkId: number;
  currentStatus?: 'RESERVED' | 'RELEASED' | string;
  currentStatusDisplay?: string;
  callbackSuccess?: () => void;
}

const BatchStatusChange: React.FC<Props> = ({
  linkId,
  currentStatus,
  currentStatusDisplay,
  callbackSuccess
}) => {
  const { updateBatchStatus, fetchingUpdateBatchStatus } = useSelectionOrderService();
  const [localStatus, setLocalStatus] = useState(currentStatus || 'RESERVED');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newStatus = e.target.value as 'RESERVED' | 'RELEASED';
    
    if (newStatus === localStatus) return;

    updateBatchStatus(linkId, newStatus, {
      onSuccess: (resp: ServiceResponse) => {
        setLocalStatus(newStatus);
        toast.success(resp.message || 'Estado actualizado correctamente');
        if (callbackSuccess) callbackSuccess();
      },
      onError: (resp: ServiceResponse) => {
        toast.error(resp.message || 'Error al actualizar el estado');
        // Revertir al estado anterior en el select
        e.target.value = localStatus;
      }
    });
  };

  return (
    <select
      className="form-select form-select-sm"
      value={localStatus}
      onChange={handleChange}
      disabled={!!fetchingUpdateBatchStatus}
      style={{ minWidth: '120px' }}
    >
      <option value="RESERVED">Tomado</option>
      <option value="RELEASED">Finalizado</option>
    </select>
  );
};

export default BatchStatusChange;